<template>
    <div>
        <el-dialog title="创建规则" :visible.sync="visible" width="400px" @close="handleClose"
            :close-on-click-modal="false" :close-on-press-escape="false">
            <el-form :model="ruleForm" ref="ruleForm" label-width="100px">
                <el-form-item label="地办">
                    <el-select v-model="ruleForm.orgCode" placeholder="请选择地办" size="small">
                        <el-option v-for="item,index in removeMutilCityArray" :key="index" :label="item.orgName" :value="item.orgCode"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="医药公司">
                    <el-select v-model="ruleForm.shopId" placeholder="请选择医药公司" size="small">
                        <el-option v-for="item,index in medicalArray" :key="index":label="item.shopName" :value="item.shopId"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="handleSubmit" size="small">确定</el-button>
                <el-button @click="visible = false" size="small">取消</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import {
    addTFGoodsSkuPrice
} from "@/api/saleRule/productLine";
export default {
    name: "CreateRuleDialog",
    props: {
        cityArray: {
            type: Array,
            default: () => []
        },
        medicalArray: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            ruleForm: {
                orgCode: "",
                shopId: "",
            },
            visible: false
        };
    },
    computed: {
        removeMutilCityArray() {
            // 对地办数组进行去重
            const cityArray = this.cityArray.filter((item, index) => {
                return this.cityArray.findIndex(i => i.orgCode === item.orgCode) === index;
            });
            return cityArray;
        }
    },
    methods: {
        publicOpen() {
            this.visible = true;
        },
        handleClose() {
            this.ruleForm = {
                orgCode: "",
                shopId: "",
            };
        },
        async handleSubmit() {
            const res = await addTFGoodsSkuPrice(this.ruleForm);
            if(res){
                this.$emit("addSuccess");
                this.visible = false;
            }
        }
    }
};
</script>


<style scoped>
.dialog-footer {
    text-align: right;
}
</style>